<i18n src="@/locales/modules/AlarmTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)"
		class="custom-dialog"
		:title="`${$t(Object.entries(this.data).length === 0 ? 'Actions.AddNew' : 'Actions.Edit')} ${$t('Alarm')}`"
		:visible.sync="isSidebarActiveLocal"
	>
		<PerfectScrollbar ref="vueScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- Name -->
				<label for class="text-base vs-input--label"> {{ $t("AlarmName") }}<span class="text-danger">*</span>: </label>

				<vs-input
					v-validate="'required'"
					:placeholder="`${$t('Actions.Input')} ${$t('AlarmName').toLowerCase()}`"
					v-model="dataName"
					:data-vv-as="$t('AlarmName')"
					class="w-full"
					name="name"
				/>
				<span class="text-danger text-sm break-normal" v-show="errors.has('name')">{{ errors.first("name") }}</span>

				<!-- Object -->
				<div class="grid grid-cols-2 mt-5">
					<div class="mb-5 pr-4">
						<label for class="text-base vs-input--label"> {{ $t("ApplyFor") }}<span class="text-danger">*</span>: </label>
						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Choose')} ${$t('Object')}`"
							v-model="object"
							name="object"
							:options="alarmObject"
							:reduce="object => object.key"
							label="value"
							:data-vv-as="$t('Object')"
							v-validate="'required'"
						/>
						<span class="text-danger text-sm break-normal" v-show="errors.has('object')">{{ errors.first("object") }}</span>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label"> trên: </label>

						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Choose')} ${$t('Properties')}`"
							v-model="column"
							:reduce="column => column.key"
							name="properties"
							:options="properties"
							label="value"
							:data-vv-as="$t('Properties')"
							v-validate="{ required: object }"
						>
							<template #no-options>
								Chọn đối tượng trước
							</template>
						</v-select>
						<span class="text-danger text-sm break-normal" v-show="errors.has('properties')">{{ errors.first("properties") }}</span>
					</div>
				</div>
				<!-- Apply scope -->
				<div class="mb-5">
					<!-- <v-select
						:clearable="false"
						multiple
						class="border-none w-full select-multiple"
						:placeholder="`${$t('Actions.Choose')} ${$t('Object')}`"
						v-model="apply_scope"
						name="apply"
						:options="apply"
						label="value"
						:data-vv-as="$t('Object')"
					/> -->
					<AlarmRelations
						:data-vv-as="$t('Object')"
						:placeholder="`${$t('Actions.PleaseChoose')}`"
						name="receiver"
						v-model="apply_scope"
						:model="objectModel"
						:addingOptions="applyAddingOptions"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('apply')">{{ errors.first("apply") }}</span>
				</div>
				<!-- Exclude scope -->
				<div class="mb-5">
					<label for class="text-base vs-input--label"> {{ $t("Exclude") }}: </label>
					<AlarmRelations
						:data-vv-as="$t('Exclude')"
						:placeholder="`${$t('Actions.Choose')} ${$t('Object').toLowerCase()} ${$t('Exclude').toLowerCase()}`"
						name="receiver"
						v-model="exclude_scope"
						:model="objectModel"
						:addingOptions="excludeAddingOptions"
					/>
				</div>
				<!-- remining times -->
				<div class="grid grid-cols-3">
					<div class="mb-5 pr-4">
						<label for class="text-base vs-input--label"> {{ $t("AlarmAt") }}: </label>
						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Choose')}`"
							v-model="operator"
							name="alarmAt"
							:reduce="operator => operator.value"
							:options="operators"
						>
						</v-select>
						<span class="text-danger text-sm break-normal" v-show="errors.has('alarmAt')">{{ errors.first("alarmAt") }}</span>
					</div>
					<div class="mb-5 pr-4 pt-6">
						<cbs-input
							v-model.number="valueOperator"
							class="w-full"
							name="valueOperator"
							dataType="int"
							v-validate="{ regex: '^[1-9]\\d*$' }"
							:data-vv-as="$t('ReminingTimes')"
							:placeholder="`${$t('InputReminingTimes')}`"
						/>
						<span class="text-danger text-sm break-normal" v-show="errors.has('valueOperator')">{{ errors.first("valueOperator") }}</span>
					</div>
					<div class="mb-5 pt-6">
						<v-select
							:clearable="false"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Choose')}`"
							v-model="unit"
							name="unit"
							:options="units"
							:reduce="unit => unit.value"
							:data-vv-as="$t('Ward')"
						/>

						<span class="text-danger text-sm break-normal" v-show="errors.has('unit')">{{ errors.first("unit") }}</span>
					</div>
				</div>
				<!-- Compare -->
				<div class="grid grid-cols-2 ">
					<div class="mb-5 pr-4">
						<label for class="text-base vs-input--label"> {{ $t("CompareWith") }}: </label>
						<v-select
							:clearable="true"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Choose')} ${$t('Properties')}`"
							v-model="column_compare"
							name="column_compare"
							:options="properties"
							:reduce="column => column.key"
							label="value"
							:data-vv-as="$t('Properties')"
							v-validate="{ required: !!operator_compare }"
						>
							<template #no-options>
								Chọn đối tượng trước
							</template></v-select
						>
						<span class="text-danger text-sm break-normal" v-show="errors.has('column_compare')">{{ errors.first("column_compare") }}</span>
					</div>
					<div class="mb-5">
						<label for class="text-base vs-input--label"> {{ $t("Calculation") }}: </label>

						<v-select
							:clearable="true"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Choose')} ${$t('Calculation').toLowerCase()}`"
							v-model="operator_compare"
							:reduce="column => column.value"
							name="operator_compare"
							:options="operatorsCompare"
							label="label"
							:data-vv-as="$t('Calculation')"
							v-validate="{ required: !!column_compare }"
						>
							<template #no-options>
								Chọn đối tượng trước
							</template>
						</v-select>
						<span class="text-danger text-sm break-normal" v-show="errors.has('operator_compare')">{{ errors.first("operator_compare") }}</span>
					</div>
				</div>
				<!-- AlarmNotiType -->
				<div class="grid grid-cols-3">
					<label for class="text-base vs-input--label">{{ $t("AlarmNotiType") }}<span class="text-danger">*</span>:</label>
					<vs-checkbox v-model="alarmNotiType" name="alarmNotiType" :data-vv-as="$t('AlarmNotiType')" v-validate="'required'" :vs-value="$constant.ALARM_NOTI_TYPE.APP">Ứng dụng</vs-checkbox>
					<vs-checkbox v-model="alarmNotiType" name="alarmNotiType" :data-vv-as="$t('AlarmNotiType')" v-validate="'required'" :vs-value="$constant.ALARM_NOTI_TYPE.MAIL">Email</vs-checkbox>
					<span class="text-danger text-sm break-normal" v-show="errors.has('alarmNotiType')">{{ errors.first("alarmNotiType") }}</span>
				</div>
				<!-- receiver -->
				<div class="mt-5">
					<label for class="text-base vs-input--label">{{ $t("Receiver") }}<span class="text-danger">*</span>:</label>
					<cbs-relations-humanroles
						:data-vv-as="$t('Receiver')"
						:placeholder="`${$t('Actions.Choose')} ${$t('Receiver').toLowerCase()}`"
						name="receiver"
						v-model="receiver"
						:type="1"
						:for="'people'"
						v-validate="'required'"
						filter="Employee"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('receiver')">{{ errors.first("receiver") }}</span>
				</div>
				<!-- receiver lv2-->
				<div class="mt-5">
					<label for class="text-base vs-input--label">{{ $t("ReceiverLv2") }}<span class="text-danger">*</span>:</label>
					<cbs-relations-humanroles
						:data-vv-as="$t('ReceiverLv2')"
						:placeholder="`${$t('Actions.Choose')} ${$t('ReceiverLv2').toLowerCase()}`"
						name="receiver_lv2"
						v-model="receiver_lv2"
						:type="1"
						:for="'people'"
						v-validate="'required'"
						filter="Employee"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('receiver_lv2')">{{ errors.first("receiver_lv2") }}</span>
				</div>
				<!-- RemindTime -->
				<div class="grid grid-cols-2 mt-5 items-center">
					<div class="flex items-center">
						<label for class="text-base vs-input--label">{{ $t("RemindTime") }}:</label>
						<cbs-input
							v-model.number="reminingTimes"
							class="w-1/2 ml-3"
							name="reminingTimes"
							dataType="int"
							v-validate="{ regex: '^[1-9]\\d*$' }"
							:data-vv-as="$t('ReminingTimes')"
							:placeholder="`${$t('InputReminingTimes')}`"
						/>
					</div>
					<div class="text-right">
						<vs-checkbox v-model="untilReceived">
							<div v-html="$t('UntileAccept')"></div>
						</vs-checkbox>
					</div>
				</div>
				<!-- DESCRIPTION -->
				<div class="description my-5">
					<label for class="vs-input--label">{{ $t("Description") }}:</label>
					<cbs-editor class="normal-placeholder" :placeholder="`${$t('Placeholder.InputDescription')}`" v-model="description" />
				</div>
				<!-- tutorial -->
				<div class="description mt-5">
					<label for class="vs-input--label">{{ $t("Tutorial") }}:</label>
					<cbs-editor class="normal-placeholder" :placeholder="`${$t('Actions.Input')} ${$t('Tutorial').toLowerCase()}`" v-model="tutorial" />
				</div>
				<!-- Repeat -->
				<div class="grid grid-cols-3">
					<div class="mb-5 pr-4 pt-6">
						<div class="flex items-center">
							<label for class="text-base vs-input--label w-full"> {{ $t("Repeat") }} </label>
							<cbs-input
								v-model.number="repeatValue"
								class="w-full"
								name="valueOperator"
								dataType="int"
								v-validate="{ regex: '^[1-9]\\d*$', required: !!repeatUnit }"
								:data-vv-as="$t('ReminingTimes')"
								:placeholder="`${$t('InputReminingTimes')}`"
							/>
						</div>
						<span class="text-danger text-sm break-normal" v-show="errors.has('valueOperator')">{{ errors.first("valueOperator") }}</span>
					</div>
					<div class="mb-5 pt-6">
						<v-select
							:clearable="true"
							class="border-none w-full"
							:placeholder="`${$t('Actions.Choose')}`"
							v-model="repeatUnit"
							name="repeatUnit"
							:options="units"
							:reduce="unit => unit.value"
							:data-vv-as="$t('Unit')"
							v-validate="{ required: !!repeatValue }"
						/>

						<span class="text-danger text-sm break-normal" v-show="errors.has('repeatUnit')">{{ errors.first("repeatUnit") }}</span>
					</div>
				</div>
				<!-- End repeat -->
				<div class="text-right">
					<vs-checkbox v-model="enable">
						Bật nhắc việc
					</vs-checkbox>
				</div>
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center flex-wrap items-center" slot="footer">
			<vs-button :type="dataId ? 'filled' : 'border'" :class="['w-full sm:w-1/3 sm:mr-6 font-bold', { 'mb-3 sm:mb-0': !dataId }]" @click.stop="submitData(!!dataId)">
				{{ dataId ? $t("Actions.Save") : $t("Actions.SaveAndRecreate") }}
			</vs-button>
			<vs-button v-show="!dataId" class="w-full sm:w-1/3 font-bold" @click.stop="submitData(true)">{{ $t("Actions.Save") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import vSelect from "vue-select";
import * as _ from "lodash";
import CbsTags from "@/components/cbs-tags/CbsTags";
import CbsEditor from "@/components/cbs-editor/CbsEditor";
import alarmCardGql from "@/http/requests/cbs/alarm_gql";
import AlarmRelations from "@/components/alarm-relations/AlarmRelations.vue";
export default {
	name: "AlarmSettingForm",

	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	watch: {
		isSidebarActive(val) {
			if (!val) {
				this.initValues();
				return;
			}
			if (Object.entries(this.data).length === 0) {
				this.initValues();
			} else {
				let { id, name, form_data, enable, until_received } = this.data;
				this.dataId = id;
				this.dataName = name;
				if (form_data && form_data !== "") {
					form_data = JSON.parse(form_data);
					this.reminingTimes = form_data.remining_times ? form_data.remining_times : null;
					const conditions = JSON.parse(form_data.conditions);
					const properties = JSON.parse(form_data.properties);
					this.object = conditions.object;
					this.column = conditions.column;
					this.operator = conditions.operator;
					this.valueOperator = conditions.value;
					this.unit = conditions.unit;
					this.column_compare = conditions.column_compare;
					this.operator_compare = conditions.operator_compare;
					const _repeat = form_data.repeat ? JSON.parse(form_data.repeat) : null;
					this.repeatUnit = _repeat ? _repeat.unit : null;
					this.repeatValue = _repeat ? _repeat.value : null;

					if (properties.to && properties.to.value) {
						this.receiver = properties.to.value.map(assignee => {
							return { id: assignee.id, type: assignee.type, name: assignee.name };
						});
					}
					if (properties.to_lv2 && properties.to_lv2.value) {
						this.receiver_lv2 = properties.to_lv2.value.map(assignee => {
							return { id: assignee.id, type: assignee.type, name: assignee.name };
						});
					}
					const _apply_scope = JSON.parse(form_data.apply_for);
					const _exclude_scope = JSON.parse(form_data.exclude);
					this.apply_scope = _.remove(_apply_scope, function(n) {
						return n !== null;
					});
					this.exclude_scope = _.remove(_exclude_scope, function(n) {
						return n !== null;
					});

					this.alarmNotiType = properties.notiType ? properties.notiType : [];
					this.description = properties.desc;
					this.tutorial = properties.tutorial;
					this.enable = enable;
					this.untilReceived = until_received;
				}
			}

			this.isFormDirty = false;
			this.initFormData = {
				dataId: this.dataId,
				dataName: this.dataName,
				object: this.object,
				column: this.column,
				operator: this.operator,
				valueOperator: this.valueOperator,
				unit: this.unit,
				alarmNotiType: this.alarmNotiType,
				receiver: this.receiver,
				receiver_lv2: this.receiver_lv2,
				reminingTimes: this.reminingTimes,
				enable: this.enable,
				description: this.description,
				tutorial: this.tutorial,
				untilReceived: this.untilReceived,
				apply_scope: this.apply_scope,
				exclude_scope: this.exclude_scope,
				column_compare: this.column_compare,
				operator_compare: this.operator_compare,
				repeatUnit: this.repeatUnit,
				repeatValue: this.repeatValue
			};
		},
		computedFormData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal) !== JSON.stringify(this.initFormData) && newVal.dataId === this.initFormData.dataId;
			},
			deep: true
		},
		object: {
			handler: function(newVal) {
				this.apply_scope = this.apply_scope.filter(appl => appl.key || appl.type === newVal || appl.type === "all");
				this.exclude_scope = this.exclude_scope.filter(appl => appl.key || appl.type === newVal);
			},
			deep: true
		},
		apply_scope: {
			handler: function(newVal) {
				const isCheckedAll = _.find(newVal, { type: "all" });
				if (isCheckedAll && newVal.length > 1) {
					this.apply_scope = newVal.filter(appl => appl.type === "all");
				}
				const column = _.findIndex(this.properties, { key: this.column });
				if (column === -1) {
					this.column = null;
				}
			},
			deep: true
		}
	},
	data() {
		return {
			dataId: null,
			dataName: "",
			object: null,
			column: null,
			operator: null,
			valueOperator: null,
			unit: null,
			alarmNotiType: [],
			receiver: null,
			receiver_lv2: null,
			reminingTimes: null,
			enable: true,
			description: "",
			tutorial: "",
			untilReceived: true,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			initFormData: {},
			isFormDirty: false,
			operators: [
				{ label: "Trước", value: ">" },
				{ label: "Ngay", value: "=" },
				{ label: "Sau", value: "<" }
			],
			units: [
				{ label: "Ngày", value: "days" },
				{ label: "Giờ", value: "hours" }
			],
			alarmObject: [],
			// properties: [],
			apply_scope: [],
			exclude_scope: [],
			column_compare: null,
			operator_compare: null,
			repeatUnit: null,
			repeatValue: null,
			operatorsCompare: [
				{ label: "Lớn", value: ">" },
				{ label: "Bằng", value: "=" },
				{ label: "Bé", value: "<" },
				{ label: "Lớn hơn bằng", value: ">=" },
				{ label: "Bé hơn bằng", value: "<=" }
			]
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		computedFormData() {
			return {
				dataId: this.dataId,
				dataName: this.dataName,
				object: this.object,
				column: this.column,
				operator: this.operator,
				valueOperator: this.valueOperator,
				unit: this.unit,
				alarmNotiType: this.alarmNotiType,
				receiver: this.receiver,
				receiver_lv2: this.receiver_lv2,
				reminingTimes: this.reminingTimes,
				enable: this.enable,
				description: this.description,
				tutorial: this.tutorial,
				untilReceived: this.untilReceived,
				apply_scope: this.apply_scope,
				exclude_scope: this.exclude_scope,
				column_compare: this.column_compare,
				operator_compare: this.operator_compare,
				repeatUnit: this.repeatUnit,
				repeatValue: this.repeatValue
			};
		},
		columnType() {
			const prop = _.find(this.properties, { key: this.column });
			return (prop && prop.type) || "";
		},
		applyAddingOptions() {
			if (this.object) {
				const isColValid = _.findIndex(this.alarmObject, { key: this.object });
				if (isColValid !== -1) {
					const applyScope = this.alarmObject[isColValid].apply_scope ? this.alarmObject[isColValid].apply_scope : [];
					return [
						{
							type: "all",
							value: "Tất cả"
						},
						...applyScope
					];
				} else {
					return [];
				}
			} else {
				return [];
			}
		},
		excludeAddingOptions() {
			if (this.object) {
				const isColValid = _.findIndex(this.alarmObject, { key: this.object });
				if (isColValid !== -1) {
					const excludeScope = this.alarmObject[isColValid].exclude_scope ? this.alarmObject[isColValid].exclude_scope : [];
					return [...excludeScope];
				} else {
					return [];
				}
			} else {
				return [];
			}
		},
		properties() {
			if (this.object) {
				const isColValid = _.findIndex(this.alarmObject, { key: this.object });
				if (isColValid !== -1) {
					const _properties = this.alarmObject[isColValid].properties;

					return _properties;
				} else {
					return [];
				}
			}
		},
		objectModel() {
			const idx = _.findIndex(this.alarmObject, { key: this.object });
			if (idx !== -1) {
				return this.alarmObject[idx].model;
			}
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.dataId = null;
			this.dataName = "";
			this.object = null;
			this.column = null;
			this.operator = null;
			this.valueOperator = null;
			this.unit = null;
			this.alarmNotiType = [];
			this.receiver = null;
			this.receiver_lv2 = null;
			this.reminingTimes = null;
			this.enable = true;
			this.description = "";
			this.tutorial = "";
			this.untilReceived = true;
			this.apply_scope = [{ type: "all", value: "Tất cả" }];
			this.exclude_scope = [];
			this.column_compare = null;
			this.operator_compare = null;
			this.repeatUnit = null;
			this.repeatValue = null;

			this.$validator.reset();
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			if (isCloseForm) {
				this.$emit("closeSidebar");
			}
			this.initValues();
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.dataId ? "UpdateAlarmSuccessful" : "CreatAlarmSuccessful"}`)
				}
			});
		},
		async handleCreateOrUpdateAlarm(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				if (this.dataId) {
					await this.$store.dispatch("alarmManagement/updateAlarmSetting", {
						...dataObj,
						id: this.dataId
					});
				} else {
					await this.$store.dispatch("alarmManagement/createAlarmSetting", dataObj);
				}

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				console.error("ERR", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					const _ob = _.find(this.alarmObject, { key: this.object });
					let dataObj = {
						name: this.dataName,
						remining_times: this.reminingTimes || 0,
						enable: this.enable,
						until_received: this.untilReceived,
						ref_model_name: _ob.model
					};
					const conditions = {
						object: this.object,
						column: this.column,
						operator: this.operator,
						value: this.valueOperator,
						unit: this.unit,
						column_compare: this.column_compare,
						operator_compare: this.operator_compare
					};
					const receivers = this.receiver.map(assignee => {
						return { id: assignee.id, type: assignee.type, name: assignee.name };
					});
					const receivers_lv2 = this.receiver_lv2.map(assignee => {
						return { id: assignee.id, type: assignee.type, name: assignee.name };
					});
					const properties = {
						desc: this.description,
						tutorial: this.tutorial,
						to: {
							type: "employee_id",
							value: receivers
						},
						notiType: this.alarmNotiType || [],
						to_lv2: {
							type: "employee_id",
							value: receivers_lv2
						}
					};
					if (this.dataId) {
						dataObj.id = this.dataId;
					}
					const exclude = this.exclude_scope
						? this.exclude_scope.map(excl => {
								if (excl.key) {
									return { ...excl, type: "scope" };
								} else {
									return excl;
								}
						  }) // eslint-disable-line no-mixed-spaces-and-tabs
						: [];
					const apply_for = this.apply_scope
						? this.apply_scope.map(apply => {
								if (apply.key) {
									return { ...apply, type: "scope" };
								} else {
									return apply;
								}
						  }) // eslint-disable-line no-mixed-spaces-and-tabs
						: [];
					dataObj.exclude = JSON.stringify(exclude);
					dataObj.apply_for = JSON.stringify(apply_for);
					dataObj.properties = JSON.stringify(properties);
					dataObj.conditions = JSON.stringify(conditions);
					if (this.repeatUnit) {
						dataObj.repeat = JSON.stringify({ unit: this.repeatUnit, value: this.repeatValue });
					} else {
						dataObj.repeat = "";
					}
					this.handleCreateOrUpdateAlarm(dataObj, isCloseForm);
				}
			});
		},

		triggerClickDatetimePicker() {
			this.$refs.dateTimePickerRef.$children[0].pickerVisible = true;
		},
		async getAlarmObject() {
			const res = await alarmCardGql.getAlarmObject();
			if (res.alarmObject) {
				this.alarmObject = res.alarmObject;
			}
		}
	},
	components: {
		vSelect,
		CbsTags,
		CbsEditor,
		AlarmRelations
	},
	created() {
		this.getAlarmObject();
	},
	beforeDestroy() {}
};
</script>
